import _ from 'lodash';
import { enums } from 'console-kit';
import RefData from 'ref-data';

const modes = {
  FOOTER:    'campaignFooter', // TODO: change to 'footer' with new module editor integration
  HEADER:    'campaignHeader', // TODO: change to 'header' with new module editor integration
  PROMOTION: 'promotion',
  PAGE:      'campaign', // TODO: change to 'page' with new module editor integration
  FORM:      'form',
};
modes.ALL = _.values(modes);

const views = {
  EDIT:             'edit',
  PREVIEW_DESKTOP:  'preview_desktop',
  PREVIEW_TABLET:   'preview_tablet',
  PREVIEW_MOBILE:   'preview_mobile',
  PREVIEW_FACEBOOK: 'preview_facebook',
  HELP:             'help',
};

views.ALL = _.values(views);

const screenDesignerPreviews = {
  DESKTOP: 'desktop',
  MOBILE:  'mobile',
};
screenDesignerPreviews.ALL = _.values(screenDesignerPreviews);

const desktopPreviewItem = {
  value:  screenDesignerPreviews.DESKTOP,
  height: '100%',
  width:  '100%',
  name:   'Desktop',
  icon:   enums.icons.DESKTOP,
};

const mobilePreviewItem = {
  value:  screenDesignerPreviews.MOBILE,
  width:  375,
  height: 667,
  name:   'Mobile',
  icon:   enums.icons.MOBILE,
};

const devicePreviewItems = [desktopPreviewItem, mobilePreviewItem];

const sectionEditorTabs = {
  FORM:     'form',
  DESIGN:   'design',
  ADVANCED: 'advanced',
};

const screenDesignerViews = {
  SCREENS:        'screens',
  MODULES:        'modules',
  PREVIEW:        'preview',
  RESULTS:        'results',
  EDIT:           'edit',
  ROW_EDITOR:     'rowEditor',
  STAGING:        'staging',
  SECTION_EDITOR: 'sectionEditor',
  HELP:           'help',
};

screenDesignerViews.ALL = _.values(screenDesignerViews);

const defaultDevicePreview = {
  [RefData.Enum.TYPE.DESTINATION.STORY]: screenDesignerPreviews.MOBILE,
  [RefData.Enum.TYPE.DESTINATION.WEB]:   screenDesignerPreviews.DESKTOP,
};

export default {
  modes,
  views,
  defaultDevicePreview,
  devicePreviewItems,
  screenDesignerViews,
  screenDesignerPreviews,
  sectionEditorTabs,
  desktopPreviewItem,
  mobilePreviewItem,
};
